<template>
  <div class="Contact">
    <section
      class="page-section"
      style="padding-bottom: 0 !important;"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.contactUs') }}
            </h1>
          </div>
          <div class="col-md-12">
            <div class="row contact-info-container">
              <div class="col-md-3">
                {{ $t('label.contact.hotline') }}:
              </div>
              <div class="col-md-9 content-weight">
                {{ config.VUE_APP_HOT_LINE }}
              </div>
            </div>
            <div class="row contact-info-container">
              <div class="col-md-3">
                {{ $t('label.contact.workingHours') }}:
              </div>
              <div class="col-md-9">
                <strong>{{ workingTime }}</strong>
                <br>
                <strong>{{ $t('label.workingDay') }}</strong>
              </div>
            </div>
            <div class="row contact-info-container">
              <div class="col-md-3">
                {{ $t('label.contact.eMail') }}:
              </div>
              <div class="col-md-9 content-weight">
                <a
                  :href="`mailto:${email}`"
                  target="_blank"
                >
                  {{ email }}
                </a>
              </div>
            </div>
            <div class="row contact-info-container">
              <div class="col-md-3">
                {{ $t('label.contact.facebook') }}:
              </div>
              <div class="col-md-9 content-weight">
                <a
                  :href="facebook"
                  target="_blank"
                >
                  {{ facebook }}
                </a>
              </div>
            </div>
            <div class="row contact-info-container">
              <div class="col-md-3">
                {{ $t('label.contact.instagram') }}:
              </div>
              <div class="col-md-9 content-weight">
                <a
                  :href="instagram"
                  target="_blank"
                >
                  {{ instagram }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.companyAddress') }}
            </h1>
          </div>
          <div class="col-md-12 content-weight mb-4">
            <p>
              {{ address['label_' + $i18n.locale] }}
            </p>
          </div>
          <div class="col-md-12">
            <a
              :href="map_link"
              target="_blank"
            >
              <div class="contact-map-section" />
            </a>
          </div>
        </div>
      </div>
    </section>

    <div
      class="container d-flex d-md-block justify-content-center"
      style="padding-bottom: 4em"
    >
      <div style="width: 300px;">
        <!--change redirect to home page-->
        <router-link :to="{name: 'home'}">
          <button class="full-button">
            {{ $t('button.getCashToday').toUpperCase() }}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Contact Cash hero website' }
    ]
  },
  data () {
    return {
      config: process.env,
      workingTime: process.env.VUE_APP_WORKING_TIME,
      email: process.env.VUE_APP_EMAIL,
      facebook: process.env.VUE_APP_FACEBOOK_LINK,
      instagram: process.env.VUE_APP_INSTAGRAM_LINK,
      address: {
        label_km: process.env.VUE_APP_ADDRESS_KM,
        label_en: process.env.VUE_APP_ADDRESS_EN
      },
      map_link: process.env.VUE_APP_MAP_LINK
    }
  }
}
</script>

<style scoped>
.contact-info-container {
  margin-bottom: 20px;
}

.contact-map-section {
  width: 100%;
  height: 500px;
  border-radius: var(--border-raduis);
  background-size: cover;
  background-position: center center;
  background-image: url("/img/map-working-place.png");
  background-repeat: no-repeat
}
</style>
